import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { AuditLog } from "@/CodegenTypes";
import { customMoment } from "@/main";
import JsonTable from "@/components/common/JsonTable.vue";
import { computed, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useTranslation } from "@/store/translation";



export default /*#__PURE__*/_defineComponent({
  __name: 'AuditLogs',
  setup(__props) {

const selectedDate = ref(customMoment().format('YYYY-MM-DD'))


const { result, loading } = useQuery<{ auditLogs: AuditLog[] }>(
  queries.auditLogs,
  {
    date: selectedDate
  },
  {
    fetchPolicy: "network-only",
  }
)

const { $t } = useTranslation();


const expandedRows = ref([]);

const filterQuery = ref('')

const filters = ref({ userId: "" });

const dateOptions = computed(() => {

  const prevDaysCount = 7;
  const options = [];
  for (let i = 0; i <= prevDaysCount; i++) {
    const mt = customMoment().subtract(i, 'days')
    const label = mt.format('DD MMM YYYY (ddd)')
    const value = mt.format('YYYY-MM-DD');
    options.push({ label, value });
  }
  return options;

})

const auditLogsIndexed = computed(() => {

  return result.value?.auditLogs.filter(l => {
    if (filterQuery.value.length){
      return l.actionId.includes(filterQuery.value) || l.userId.includes(filterQuery.value) || JSON.stringify(l.properties).includes(filterQuery.value);
    } else {
      return true;
    }
  }).map((auditLog, index) => ({ ...auditLog, index }));
})



function formatDatetime(dateStr: string) {
  return customMoment(dateStr).format("ddd, DD MMM yyyy hh:mm:ss A");
}


return { __sfc: true,selectedDate, result, loading, $t, expandedRows, filterQuery, filters, dateOptions, auditLogsIndexed, formatDatetime, JsonTable }
}

})